/** "How to afford Christmas and New Year's flights (2026)": metadata (the article is in ../bodies/holiday-flights-pay-over-time.js). */
export default {
  slug: 'holiday-flights-pay-over-time',
  category: 'Booking tips',
  title: 'How to afford Christmas and New Year\'s flights (2026)',
  seoTitle: 'How to Afford Christmas & New Year\'s Flights 2026',
  description: 'The cheapest days to fly around Christmas and New Year\'s 2026, when to book, holiday bag fees, and how to split the cost, with book-by dates for each departure.',
  dek: 'Holiday airfare is up this year. Here\'s what the 2026 fare data says about which days to fly, when to book, what bags will add, and how to spread the cost over the weeks before you go.',
  author: 'Stephanie Ludwig',
  published: '2026-11-03',
  updated: '2026-11-03',
  faqs: [
    {
      q: 'What is the cheapest day to fly for Christmas 2026?',
      a: 'Hopper\'s 2026 data points to Monday, December 21 and Tuesday, December 22, with domestic round trips averaging about $440. The weekend before Christmas, December 18 to 20, is the most expensive time to leave.',
    },
    {
      q: 'What day should I fly home after Christmas or New Year\'s?',
      a: 'Early-week returns such as Monday, December 28 through Wednesday, December 30 are the lower-priced option. Hopper says a Sunday, December 27 return costs about 20% more than early-week returns, and returns after January 2 average over $560.',
    },
    {
      q: 'How far ahead should I book Christmas flights?',
      a: 'Google\'s 2026 data shows Christmas fares have been lowest about 56 days before departure on average, with a typical low range of 33 to 67 days out. That usually means booking between late October and mid-November.',
    },
    {
      q: 'What is the last day to book a Christmas Eve flight on Defera?',
      a: 'December 2, 2026. Every Defera trip must depart at least 22 days after booking, so count back 22 days from your departure date. For a December 31 departure, the last day is December 9.',
    },
    {
      q: 'Is the deposit lower if I book holiday flights earlier on Defera?',
      a: 'Yes. On Defera Installments, deposits start at 40% for trips 30 to 59 days out and at 60% for trips 22 to 29 days out, so booking a Christmas Eve trip by November 24 keeps you in the 40% tier.',
    },
    {
      q: 'Can I pay for holiday flights with Klarna or Affirm?',
      a: 'Where the airline or travel site offers them, yes. Pay in 4 splits the cost into four payments two weeks apart at 0% interest when you pay on time, while Affirm monthly plans range from 0% to 36% APR based on credit.',
    },
  ],
  related: [
    'flight-payment-plans-no-credit-check',
    'lock-flight-price-with-deposit',
    'cheapest-day-to-fly',
  ],
};
